import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useEffect, useState } from 'react';

import CategoriesStore from '../../store/categories';
import { isProductDetailsPage } from '../../utils/products';
import OffersAside from '../OffersAside/OffersAside';

import CategoriesAccordion from './CategoriesAccordion';
import styles from './CategoriesAside.module.scss';

export default function CategoriesAside({ categoriesFromFile, slug, category }) {
  const [categories, setCategories] = useState([]);

  const _isProductDetailsPage = isProductDetailsPage(slug);

  useEffect(() => {
    const categories$ = CategoriesStore.subscribe(setCategories);

    return () => {
      categories$.unsubscribe();
    };
  }, []);

  if (isEmpty(categories)) {
    return (
      <aside
        className={cn(styles.aside, styles.parentIsSticky, {
          [styles.noOverflow]: _isProductDetailsPage,
        })}
      >
        <OffersAside name="Προσφορές" slugName="offers" />
        <OffersAside name="Έξυπνες αγορές" slugName="smart" isSuper />
        {categoriesFromFile &&
          categoriesFromFile.map(c => (
            <CategoriesAccordion
              categoryName={c.name}
              categorySlug={c.slugAscii}
              slug={slug}
              subCategories={c.subCategories}
              key={c._id}
              active={category?.slugAscii === c?.slugAscii}
            />
          ))}
      </aside>
    );
  }

  return (
    <aside
      className={cn(styles.aside, styles.parentIsSticky, {
        [styles.noOverflow]: _isProductDetailsPage,
      })}
    >
      <OffersAside name="Προσφορές" slugName="offers" />
      <OffersAside name="Έξυπνες αγορές" slugName="smart" />
      {categories &&
        categories.map(c => (
          <CategoriesAccordion
            categoryName={c.name}
            categorySlug={c.slugAscii}
            slug={slug}
            subCategories={c.subCategories}
            key={c._id}
            active={category?.slugAscii === c?.slugAscii}
          />
        ))}
    </aside>
  );
}
